<template>
  <div>
    <v-layout dark justify-center row wrap style="padding-top: 100px;">
      <v-flex xl3 lg4 md5 sm6 xs12>
        <v-card>
          <v-toolbar class="grey darken-4" dark>
            <img src="../assets/kepit_logo_full.png" style="height: 60px;">
            <v-spacer></v-spacer>
            <v-toolbar-title style="margin-right: 16px;">Admin</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 v-show="showError">
                <v-alert error value="true">
                  {{errormsg}}
                </v-alert>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Email"
                  type="email"
                  v-model="loginForm.email"
                  v-on:keyup.enter="login"
                  :disabled="maintenance"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Password"
                  v-model="loginForm.password"
                  type="password"
                  v-on:keyup.enter="login"
                  :disabled="maintenance"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="maintenance || $route.query.l == '1'" @click="login" flat class="orange--text">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      loginForm: {
        email: "",
        password: ""
      },
      errormsg: "",
      showError: false
    }
  },
  methods: {
    login () {
      this.$store.dispatch("log_in", this.loginForm).then(() => {
        this.$router.push(this.$route.query.redirect||"/")
        this.loginForm.email = ""
        this.loginForm.password = ""
      },
      (error) => {
        this.loginForm.password = ""
        console.log(error);
        this.errormsg = error.msg
        this.showError = true
      });
    }
  },
  computed: {
    maintenance() {
      return this.$store.state.maintenance.running && this.$store.state.maintenance.info.start_time <= moment().unix();
    }
  },
  created() {
    if(this.$route.query.l == "1") {
      this.$router.push("/login");
      this.$nextTick(() => {
        location.reload();
      })
    }
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {

      this.$store.commit('set_darkmode', e.matches)

    });

    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      this.$store.commit('set_darkmode', true)
    }
  }
}
</script>

<style>
body {

}

</style>
<style scoped>
.logo img {
  max-width: 100%;
  max-height: 80%;
}
</style>
